import React, { useState } from "react";
import ReactDOM from "react-dom";
import styles from "../../styles/crearEmpresaPopup.module.css";
import { useTranslation } from "react-i18next";

const TEMPLATE_FILE = "SystemicSurveyTemplate.xlsx";
const TEMPLATE_DOWNLOAD_NAME = "Systemic Survey Template.xlsx";

const ImportarEmpleadosPopup = ({ onClose, onImport }) => {
  const [file, setFile] = useState(null);
  const { t } = useTranslation();

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const templateUrl = `${process.env.PUBLIC_URL || ""}/files/${TEMPLATE_FILE}`;

  const handleImport = () => {
    if (file) {
      onImport(file);
      onClose();
    }
  };

  const handleClickOutside = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return ReactDOM.createPortal(
    <div className={styles.popupOverlay} onClick={handleClickOutside}>
      <div className={styles.popupContent}>
        <h2>{t("importUsers")}</h2>
        <p>{t("importInstructions")}</p>
        <a href={templateUrl} download={TEMPLATE_DOWNLOAD_NAME} className={styles.downloadLink}>
          {t("downloadTemplate")}
        </a>
        <input type="file" onChange={handleFileChange} className={styles.fileInput} accept=".xlsx, .xls" />
        <div className={styles.popupActions}>
          <button onClick={onClose} className={styles.buttonCancel}>{t("cancel")}</button>
          <button onClick={handleImport} className={styles.buttonImport}>{t("import")}</button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ImportarEmpleadosPopup;
